export interface Skill {
  name: string;
  category: "frontend" | "backend" | "tools" | "database" | "design" | "cms";
}

export const skills: Skill[] = [
  // Frontend
  { name: "React", category: "frontend" },
  // { name: "React Native", category: "frontend" },
  { name: "NextJS", category: "frontend" },
  // { name: "Vue.js", category: "frontend" },
  { name: "TypeScript", category: "frontend" },
  { name: "JavaScript", category: "frontend" },
  { name: "HTML", category: "frontend" },
  { name: "CSS", category: "frontend" },
  { name: "TailwindCSS", category: "frontend" },
  { name: "ShadCN", category: "frontend" },

  // Backend
  { name: "NestJS", category: "backend" },
  { name: "NodeJS", category: "backend" },
  // { name: "Java", category: "backend" },
  { name: "PHP", category: "backend" },

  // Database
  { name: "MySQL", category: "database" },
  { name: "PostgreSQL", category: "database" },
  { name: "MongoDB", category: "database" },
  { name: "Airtable", category: "database" },

  // DevOps / Outils
  { name: "Git", category: "tools" },
  { name: "GitLab", category: "tools" },
  { name: "Docker", category: "tools" },

  // CMS
  { name: "WordPress", category: "cms" },
  { name: "Elementor", category: "cms" },

  // Design
  { name: "Figma", category: "design" },
  { name: "Canva", category: "design" },
];

export const categories = [
  {
    id: "frontend",
    name: "Frontend",
    icon: "🎨",
    color: "from-blue-500 to-cyan-500",
  },
  {
    id: "backend",
    name: "Backend",
    icon: "⚙️",
    color: "from-green-500 to-emerald-500",
  },
  {
    id: "database",
    name: "Base de Données",
    icon: "🗄️",
    color: "from-primary-500 to-blue-500",
  },
  {
    id: "tools",
    name: "DevOps / Outils",
    icon: "🛠️",
    color: "from-gray-500 to-slate-500",
  },
  {
    id: "cms",
    name: "CMS",
    icon: "📝",
    color: "from-purple-500 to-pink-500",
  },
  {
    id: "design",
    name: "Design",
    icon: "🎨",
    color: "from-orange-500 to-red-500",
  },
];
